import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a073ec3f6558f00148401c8/tradewithkrish/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a073ec3f6558f00148401c8/tradewithkrish/src/app/components/FiiDiiChartSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a073ec3f6558f00148401c8/tradewithkrish/src/app/components/NiftyChartSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a073ec3f6558f00148401c8/tradewithkrish/src/components/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a073ec3f6558f00148401c8/tradewithkrish/src/components/Topbar.tsx");
